
export default {
  props: {
    marginY: {
      type: String,
      default: 'my-11'
    }
  }
};
